<template>
  <div>
    <!-- 基本信息-入住需求-->
    <roomBasic  :ruleForm="formData" v-show="tabLabel===1" class="room-Type" :modify="modify" ref="roomBasic"></roomBasic>
    <!--填写完成-->
    <div class="statusBar">
      <ul v-if="tabLabel>1">
          <li class="complete" v-if="tabLabel>1" @click="switchNeeds(1)">
              <div> 入住需求</div>
              <div class="text-success">填写完成<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
          <li class="complete" v-if="tabLabel==3" @click="switchNeeds(2)">
              <div> 会议需求<span class="text-ris">(非必填·有会议需求可去添加)</span></div>
              <div :class="formData.meeting_need.length>0?'text-success':'text-danger'">{{formData.meeting_need.length>0?'填写完成':'未填写' }}<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
          <li class="complete" v-if="tabLabel==2&&modify" @click="switchNeeds(3)">
              <div> 其他需求<span class="text-ris">(非必填·会场费、餐饮、住宿费用)</span></div>
              <div :class="formData.add_need.length>0?'text-success':'text-danger'">{{formData.add_need.length>0?'填写完成':'未填写' }}<i class="el-icon-arrow-right ml-2"></i></div>
          </li>
      </ul>
    </div>
    <!--会议需求-->
    <meetingType v-show="tabLabel===2" class="room-Type mt-4" :meeting_need="formData.meeting_need" :modify="modify"  ref="meetingType"></meetingType>
    <!--其他需求-->
    <other v-show="tabLabel===3" :add_need="formData.add_need" class="room-Type mt-3" ref="other"></other>
    <!--确认发布订单-->
    <div class="room-type-footer mt-4 room-Type room-bottom">
      <template v-if="tabLabel===1">
        <el-button type="primary" @click="roomBasicBottom()">下一步、填写会议需求</el-button>
      </template>
      <template v-if="tabLabel>1">
        <!-- <el-button @click="back()">返回修改</el-button> -->
        <el-button type="primary" @click="submitForm()">确认发布订单</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import roomBasic from './Components/roomBasic.vue';
import meetingType from './Components/meetingType.vue'             //会议需求
import other from './Components/other.vue'                         //其他需求
export default {
  name: 'Meeting',
  components: {roomBasic, meetingType,other},
  props: {
    //订单详情
    orderDetail: {
      type: Object,
      default: () => {}
    },
    //是否修改订单
    modify: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  data() {
    return {
        tabLabel: 1,                                //标签页：1入住需求、2房型需求
        formData:{
            order_type: 2,                            //订单类型：1住宿订单、2纯会议订单
            team_type: 2,                             //团队类型：1旅游团、2会议团
            title: '',                                //团号标题
            province:'',                              //目的地省份
            city:'',                                  //目的地城市
            district:[],                                //目的地区县
            star:[],                                  //酒店星级
            num:'',                                   //人数
            breakfast:'',                             //早餐需求
            meeting_need: [],                         //会议需求
            other:[],                                 //其他需求
            remark:'',                                //备注
            add_need:[],                              //附加需求
        },
    };
  },
  computed: {},
  watch: {
    orderDetail: {
      handler(newVal, oldVal) {
        this.initModifyOrder(newVal);
      },
      deep: true
    },
  },
  created() {},
  mounted() {},
  methods: {
    //提交表单
    submitForm(e) {
      //已填写完基本信息切换房型需求
      let isSubmit = this.isSubmitForm();
      //纯会议最后添加一个会议
      if(isSubmit.meeting_need.length==0){
        return this.$message.error('请添加一个会议需求');
      }
      //确认订单弹出确认框
      if(isSubmit){
        this.formData = {...this.formData,...isSubmit};
        this.$emit('submitForm',this.formData);
        console.log('验证通过')
      }
    },
    //修改订单初始化
    initModifyOrder(res){
      res=JSON.parse(JSON.stringify(res));       //防止连带
      let Value=this.$_Object.getSecondObjIntersectionValues(this.formData,res);       //只获取交集对象
      Value = this.$_Object.convertCommaValueToArray(Value, false, true);              //带','转为数组
      // 需要转数字的字段数组
      const numKeys = ['order_type', 'city', 'province', 'breakfast']
      numKeys.forEach(key => Value[key] = Number(Value[key]));
      //时间变转毫秒级
      if(res.meeting_need_arr.list){
       res.meeting_need_arr=res.meeting_need_arr.list.map(user=>{
        return{
          ...user,
          date:user.date*1000
        }
      });
      }
      Value={
        ...this.formData,
        ...Value,
        order_type:2,
        team_type:2,                                                          //订单类型             
        district:this.$_Array.commaStrToArray(Value.district)||[],             //区转为数组、方便确认单
        star:this.$_Array.commaStrToArray(Value.star)||[],                     //星级转为数组、方便确认单
        other:this.$_Array.commaStrToArray(Value.other)||[],                   //其他需求转为数组、方便确认单
        meeting_need:res.meeting_need_arr,                                     //会议需求
      } 
      this.formData = Value;      //赋值给表单数据
      console.log(this.formData,'表单');
    },
    //*****************确认订单方法*****************//
    //调用基本信息确认方法
    async roomBasicBottom(){
      let {isSubmit,formData} = await this.$refs.roomBasic.submitForm();       //调用基本信息确认方法
      this.formData = {...this.formData,...formData};
      if(isSubmit){
        this.tabLabel = 2;
      }
    },
    //切换其他需求
    switchNeeds(i){
      //判断当前房型是全部填完
      let isSubmit = this.isSubmitForm();
      if(isSubmit){
        this.tabLabel = i;
      }
    },
    //判断当前需求是否填写完整
    isSubmitForm(){
      if(this.tabLabel===2){
        return this.$refs.meetingType.submitForm();
      }
      if(this.tabLabel===3){
        return this.$refs.other.submitForm();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
    .statusBar{
      background-color: #fff;
      box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
      margin-top: 16px;
      border-radius: 6px;
      li:nth-child(2),li:nth-child(3){
        border-top: 1px solid var(--smtc-color-bg-border-gray);
      }
    }
    .complete{
        width: 94%;
        display: flex;
        justify-content: space-between;
        padding: 20px 3%;
        cursor: pointer;
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 3%;
        border-radius: 6px;
    }
    .text-ris{
      color: #999;
      margin-left: 12px;
    }
    .fillin{
      display: flex;
      justify-content:space-between;
      border-top: 1px solid var(--smtc-color-bg-border-gray);
      li{
        width: 50% !important;
      }
      li:nth-child(1){
        border-right: 1px solid var(--smtc-color-bg-border-gray);
      }
    }
    .room-bottom{
      width: 96%;
      padding: 2%;
      position: sticky;
      bottom: 0;
      left: 0 ;
      z-index: 9;
    }
</style>